import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GET_GATEWAY_FROM_SETTLEMENT_ACCOUNT } from '../queries/payment.queries';
import { StorageService } from './storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import {
  PaymentGateways,
  Currency,
  CurrencySymbol,
} from '../enums/payment-gateways.enum';
import { CustomerInput } from '../models/customer.model';
import {
  CHARGE,
  GET_PAYMENT_METHOD,
  SAVE_CARD,
} from '../queries/simpayx-payment-queries';
import { PaymentRequestInput } from '../models/simpayx-payment-request-model';

@Injectable({
  providedIn: 'root',
})
export class PaymentGatewaysService {
  constructor(private apollo: Apollo, private storageService: StorageService) {}

  getPaymentGateway() {
    return this.apollo
      .watchQuery({
        query: GET_GATEWAY_FROM_SETTLEMENT_ACCOUNT,
        variables: {
          businessId: this.storageService.getLocalStorageData(
            LOCAL_STORAGE.BUSINESS_VALUES
          ).businessId,
          merchantId: this.storageService.getLocalStorageData(
            LOCAL_STORAGE.BUSINESS_VALUES
          ).merchantId,
        },
      })
      .valueChanges.subscribe((res: any) => {
        if (res) {
          if (res.data.GetSettlementAccountsType) {
            let gateway: PaymentGateways =
              res.data.GetSettlementAccountsType[0].accountType;
            console.log('gateway', gateway);

            switch (gateway) {
              case PaymentGateways.STRIPE:
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.CURRENCY,
                  Currency.AMERICAN_DOLLAR
                );
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.CURRENCY_SYMBOL,
                  Currency.AMERICAN_DOLLAR
                );
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.PAYMENT_GATEWAY,
                  gateway
                );
                // LocalStorageService.setValue(
                //   LOCAL_STORAGE.CURRENCY,
                //   Currency.AMERICAN_DOLLAR
                // );
                // LocalStorageService.setValue(
                //   LOCAL_STORAGE.CURRENCY_SYMBOL,
                //   CurrencySymbol.AMERICAN_DOLLAR
                // );
                // LocalStorageService.setValue(
                //   LOCAL_STORAGE.PAYMENT_GATEWAY,
                //   gateway
                // );
                break;
              case PaymentGateways.RAZORPAY:
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.CURRENCY,
                  Currency.INDIAN_RUPEES
                );
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.CURRENCY_SYMBOL,
                  Currency.INDIAN_RUPEES
                );
                this.storageService.setLocalStorageData(
                  LOCAL_STORAGE.PAYMENT_GATEWAY,
                  gateway
                );
                break;
              default:
                break;
            }
          }
        }
      });
  }

  public saveCard(paymentMethodId: String, customer: CustomerInput) {
    let businessId: String = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;
    // let businessDetails = {
    // businessId: businessId
    // }
    return this.apollo.mutate({
      mutation: SAVE_CARD,
      variables: {
        paymentMethodId: paymentMethodId,
        customer: customer,
        businessId: businessId,
      },
    });
  }
  public createCharges(paymentRequest: PaymentRequestInput) {
    console.log('paymentRequest', paymentRequest);

    return this.apollo.watchQuery({
      query: CHARGE,
      variables: {
        paymentRequest: paymentRequest,
        isTnCAccepted: true,
      },
    });
  }

  public getPaymentMethodList(customerId: String) {
    // let customerId = "cus_LsIAIkqcvRwHVh"
    let businessId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;

    return this.apollo.watchQuery({
      query: GET_PAYMENT_METHOD,
      variables: {
        customerId: customerId,
        businessId: businessId,
      },
    }).valueChanges;
  }
}
